__turbopack_context__.v({
  "btn": "Qfsr0a_btn",
  "btn--block": "Qfsr0a_btn--block",
  "btn--filled": "Qfsr0a_btn--filled",
  "btn--filled-accent": "Qfsr0a_btn--filled-accent",
  "btn--filled-inverse": "Qfsr0a_btn--filled-inverse",
  "btn--filled-subtle": "Qfsr0a_btn--filled-subtle",
  "btn--ghost": "Qfsr0a_btn--ghost",
  "btn--l": "Qfsr0a_btn--l",
  "btn--loading": "Qfsr0a_btn--loading",
  "btn--m": "Qfsr0a_btn--m",
  "btn--outlined": "Qfsr0a_btn--outlined",
  "btn--rounded": "Qfsr0a_btn--rounded",
  "btn--s": "Qfsr0a_btn--s",
  "btn--stretch": "Qfsr0a_btn--stretch",
  "btn--xs": "Qfsr0a_btn--xs",
  "icon": "Qfsr0a_icon",
  "pdsbutton-spin": "Qfsr0a_pdsbutton-spin",
  "spinner": "Qfsr0a_spinner",
});
